import {
    Button,
    Card,
    CircularProgress,
    Grid,
    InputLabel,
    makeStyles,
} from "@material-ui/core";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { Skeleton } from "@material-ui/lab";
import { InputField } from "../ccmode2.0/CcmodeSetupNew/FormFields";
import { TfiSave } from "react-icons/tfi";

const siteUrlValidation = Yup.object().shape({
    siteUrl: Yup.string().required("site url is required"),
});

const useStyles = makeStyles((theme) => ({
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
    copyInner: {
        display: "flex",
        [theme.breakpoints.down("xs")]: {
            flexGrow: 1,
        },
    },
    textField: {
        "& .MuiInputBase-input.Mui-disabled": {
            padding: "12.5px 14px",
        },
    },
    cardContainer: {
        padding: theme.spacing(5),
        width: "65%",
        margin: "0 auto",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            padding: theme.spacing(2),
        },
    },
}));

const WooCommerceInstallForm = ({ feedsetting, language, setUpdateData }) => {
    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            siteUrl: feedsetting?.wordpress_site_url
                ? new URL(feedsetting.wordpress_site_url).origin
                : "",
        },
        enableReinitialize: true,
        validationSchema: siteUrlValidation,
        onSubmit: handleSubmit,
    });

    async function handleSubmit(values, actions) {
        actions.setSubmitting(true);
        try {
            const response = await axios.get(
                `${NODE_API_URL}/INTL/woocommerce/install?siteUrl=${values.siteUrl}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get(
                            "cust_auth_token"
                        )}`,
                    },
                }
            );

            if (response && response.data && response.data.success) {
                setUpdateData(true);
                toast.success(response.data.message);
            }
        } catch (error) {
            if (error?.response?.data?.message === "UnAuthorized!") {
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                    if (cookies[i] && !cookies[i].includes("view")) {
                        var equals = cookies[i].indexOf("=");
                        var name =
                            equals > -1
                                ? cookies[i].substr(0, equals)
                                : cookies[i];
                        document.cookie =
                            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    }
                }

                window.location.replace(`${BASE_URL}/logout`);
            } else if (error?.response?.data?.message) {
                formik.setFieldError("siteUrl", error.response.data.message);
            } else {
                formik.setFieldError("siteUrl", error.message);
            }
        } finally {
            actions.setSubmitting(false);
        }
    }

    if (!feedsetting) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    return (
        <Card className={classes.cardContainer}>
            <FormikProvider value={formik}>
                <Form id="woocommerceSiteUrl">
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Register your woocommerce site
                                <span className="small d-block mt-2 line-height-lg">
                                    Enter the url of your woocommerce site.
                                </span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputField
                                className={classes.textField}
                                fullWidth
                                name="siteUrl"
                                value={formik.values?.siteUrl || ""}
                                InputProps={{
                                    style: {
                                        height: "40px",
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item style={{ marginLeft: "auto" }}>
                            <Button
                                disabled={formik.isSubmitting}
                                variant="contained"
                                color="primary"
                                className={classes.saveBtn}
                                onClick={() => {
                                    formik.submitForm();
                                }}
                            >
                                <TfiSave className="mr-3" size={13} /> Register
                                {formik.isSubmitting && (
                                    <CircularProgress
                                        size={16}
                                        className={"ml-3"}
                                    />
                                )}
                            </Button>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            style={{ textTransform: "capitalize" }}
                        >
                            <hr className="w-100" />
                            <h5>
                                Follow these steps to register your WooCommerce
                                site:
                            </h5>
                            {(() => {
                                const STEPS = [
                                    "Enter your WooCommerce site URL.",
                                    "Click Register..",
                                    "After registering, you will be redirected to the WooCommerce Settings page.",
                                ];

                                return (
                                    <div className="p-4">
                                        {STEPS.map((step, idx) => (
                                            <li
                                                key={idx}
                                                className="font-size-lg text-semibold my-1"
                                            >
                                                {step}
                                            </li>
                                        ))}
                                    </div>
                                );
                            })()}
                        </Grid>
                    </Grid>
                </Form>
            </FormikProvider>
        </Card>
    );
};

export default WooCommerceInstallForm;
